import React, { useRef } from 'react';
// Utils
import cn from '@/utils/cn';
// Components
import { ColorThemeEnum } from '@/enum/ColorThemeEnum';
import Picto, { PictoName } from '../Picto/Picto';
// Styles
import styles from './OptionButton.module.css';
// Types

interface OptionButtonProps {
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  color?: ColorThemeEnum.YELLOW | ColorThemeEnum.ORANGE | ColorThemeEnum.PURPLE;
  className?: string;
  icon?: PictoName;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  isSelected?: boolean;
}

function OptionButton({
  children,
  onClick = () => {},
  color = ColorThemeEnum.PURPLE,
  className,
  icon,
  type = 'button',
  disabled = false,
  isSelected = false,
}: OptionButtonProps) {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const buttonBackgroundRef = useRef<HTMLDivElement>(null);

  const handleUpdateBackgroundPosition = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!buttonRef.current || !buttonBackgroundRef.current) return;

    const buttonElement = buttonRef.current;
    const backgroundElement = buttonBackgroundRef.current;
    const buttonWidth = buttonElement.getBoundingClientRect().width;
    const x = event.clientX - buttonElement.getBoundingClientRect().left - buttonWidth / 2;
    const y = event.clientY - buttonElement.getBoundingClientRect().top - buttonWidth / 2;

    backgroundElement.style.left = `${x}px`;
    backgroundElement.style.top = `${y}px`;
  };

  return (
    <button
      ref={buttonRef}
      // eslint-disable-next-line react/button-has-type
      type={type}
      className={cn([
        styles.button,
        styles.regular,
        styles.bordered,
        styles[color],
        isSelected && styles.selected,
        className || '',
      ])}
      onMouseMove={handleUpdateBackgroundPosition}
      onClick={onClick}
      disabled={disabled}
    >
      <div className={styles.inner}>
        {children}
        {icon && <Picto icon={icon} width={22} />}
      </div>
      <div ref={buttonBackgroundRef} className={styles.background} />
    </button>
  );
}

export default OptionButton;
